import qs from 'query-string'
import {
  pick,
  reject
} from 'ramda'

import { isObject } from 'utils'

const setQueryStringWithoutPageReload = qsValue => {
  const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${qsValue}`

  window.history.replaceState({ path: newurl }, '', newurl)
}

export const getQueryStringValues = (keys, queryString = window.location.search) => {
  const parsedQueryString = qs.parse(queryString, {
    parseBooleans: true,
    parseNumbers: true
  })


  return pick(keys, parsedQueryString)
}

export const setQueryStringValue = (newValue, queryString = window.location.search) => {
  const parsedValues = qs.parse(queryString)
  const newValues = reject(isObject, {
    ...parsedValues,
    ...newValue
  })

  setQueryStringWithoutPageReload(qs.stringify(newValues))
}
